import { Injectable } from '@angular/core';
import { IDocument } from '../database/generic';
import { AngularFirestore } from '@angular/fire/compat/firestore';

export interface IHTUsers extends IDocument {
  eventId: string;
  bartenderId: string;
  eventStandId: string;
}

@Injectable({
  providedIn: 'root'
})
export class HTUsersService {

  constructor(
    private afStore: AngularFirestore
  ) { }

  getUsers(eventId: string) {
    return this.afStore.collection<IHTUsers>(`event/${eventId}/htusers`).valueChanges({ idField: 'key' });
  }

  deleteUser(eventId: string, id: string) {
    return this.afStore.doc<IHTUsers>(`event/${eventId}/htusers/${id}`).delete();
  }

  addUser(eventId: string) {
    return this.afStore.collection<IHTUsers>(`event/${eventId}/htusers`).add({
      eventId,
      eventStandId: 'hteventstand',
      bartenderId: 'hteventstand'
    })
  }
}
